import axios from "axios";
import * as URL from "../../helpers/Constants";

export default class PMSPrescriptionSettingsServices {

    static getPrescriptionSettingsByPharmacyId(id) {
        return axios.get(`${URL.PMS_GET_PRESCRIPTION_CONFIG_BY_PHARMACY_ID}/${id}`, PMSPrescriptionSettingsServices.getAuthHeader());
    }

    static getPrescriptionByDoctor() {
        return axios.get(URL.PMS_GET_PRESCRIPTION_CONFIG_BY_DOCTOR, PMSPrescriptionSettingsServices.getAuthHeader());
    }

    static savePrescriptionSettings(data, id) {
        return axios.post(`${URL.PMS_SAVE_PRESCRIPTION_CONFIG}/${id}`, {bottomText: data.bottomText || "", logo: data.logo || ""}, PMSPrescriptionSettingsServices.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {headers: {"Authorization": `Bearer ${accessToken}`}};
    }

}
